module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Bold-f68e19c6a1e6c6c42de1af00649c2f2a.ttf";